module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-container",
    style: (_vm.demoContainerStyle)
  }, [_c('span', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _c('button', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加元素")])]), _c('div', {
    staticClass: "divider"
  }), _c('div', {
    style: (_vm.demoStyle),
    attrs: {
      "id": "demo"
    }
  }, _vm._l((_vm.demoItems), function(uid, index) {
    return _c('CompDemoItem', {
      key: uid,
      attrs: {
        "num": index,
        "uid": uid,
        "itemProps": _vm.demoItemProps[uid]
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f4dfe93"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Demo.vue
// module id = 98
// module chunks = 1